/// <reference path="../_references.ts"/>

module App.Administrative.SendInvoice {
	import AdministrativeService = App.Administrative.AdministrativeService;
	import Appointment = App.Appointments.Appointment;
	import SelectedAppointment = App.Appointments.SelectedAppointment;
	import TitleBarService = App.Helpers.TitleBarService;
	import ToastService = App.Utils.ToastService;
	import CustomerService = App.Customer.CustomerService;

	export class SendInvoiceController {
		static $inject: string[] = [
			'$state', '$q', 'AdministrativeService', 'TitleBarService', 'SelectedAppointment', 'ToastService', 'CustomerService'
		];

		appointment: Appointment = null;
		correctDataText: string = 'Is this the correct email or phone number to send the review request to?'
		customerName: string = '';

		email: string = null;
		note: string = null;
		syncAccounting: boolean = false;
		sendEmail: boolean = false;
		closeSR: boolean = false;

		editEmailFlyout: boolean = false;
		edittedEmail: string = '';
		showNewEmail: boolean = false;
		newEmail: string = '';

		loading: boolean = true;

		constructor(
			private $state: ng.ui.IStateService,
			private $q: ng.IQService,
			private AdministrativeService: AdministrativeService,
			private TitleBarService: TitleBarService,
			private SelectedAppointment: SelectedAppointment,
			private ToastService: ToastService,
			private CustomerService: CustomerService
		) {
			TitleBarService.set('Appointment');

			SelectedAppointment.getAppointment().then((appointment) => {
				this.setAppointment(appointment);

				$q.all({
					serviceRequest: AdministrativeService.GetServiceRequestChecklist(this.appointment.service_request.id),
					appointment: AdministrativeService.GetAppointmentChecklist(this.appointment.id),
				}).then((data) => {
					this.note = data.serviceRequest.data.invoice_note || this.note;
					this.email = data.serviceRequest.data.invoice_email || this.email;
					this.syncAccounting = data.serviceRequest.data.upload_on_complete;
					this.sendEmail = data.serviceRequest.data.email_on_complete;
					this.closeSR = data.appointment.data.close_service_request_on_complete;

					this.loading = false;
				});
			});
		}

		editEmail() {
			this.email = this.edittedEmail;
			this.editEmailFlyout = false;

			if (this.showNewEmail) {
				this.CustomerService.createEmail(this.appointment.service_request.customer.id, this.newEmail).then((email) => {
					this.appointment.service_request.customer.emails.push(email.data);
					this.email = this.edittedEmail = email.data.email;
					this.newEmail = '';
					this.showNewEmail = false;
					this.ToastService.show('Email created');
				});
			}
		}

		save() {
			this.$q.all({
				serviceRequest: this.AdministrativeService.UpdateServiceRequestChecklist(this.appointment.service_request.id, {
					invoice_email: this.email,
					invoice_note: this.note,
					upload_on_complete: this.syncAccounting,
					email_on_complete: this.sendEmail
				}),
				appointment: this.AdministrativeService.UpdateAppointmentChecklist(this.appointment.id, {
					close_service_request_on_complete: this.closeSR
				}),
			}).then(() => {
				this.$state.go('zipSolutions.administrative');
			}).catch((response) => {
				this.ToastService.showError('Unable to update appointment: ', response);
			});
		}

		setAppointment(appointment: Appointment): void {
			const vm = this;

			vm.appointment = appointment;

			if(vm.appointment.service_request.customer.emails.length > 0) {
				vm.email = vm.appointment.service_request.customer.emails[0].email;
				vm.edittedEmail = vm.email;
			}

			vm.customerName = vm.appointment.service_request.customer.full_name;
		}
	}
}